import React from 'react'
import MenuContent from './menuContent.jsx'
import RelatedPagesInFolder from './relatedPagesInFolder.jsx'
import FaceBookPlugin from './faceBookPlugin.jsx'
import TwitterPlugin from './twitterPlugin.jsx'

const CustomSection = props => {
  return (
    <div id={props.id}>
      <MenuContent {...props} />
      <RelatedPagesInFolder {...props} />
      <FaceBookPlugin />
      <TwitterPlugin />
    </div>
  )
}

export default CustomSection



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/customSection.jsx